import { createMutationHelper } from '@utils/swr'
import { type AxiosPromise } from 'axios'
import { type ECommercePaymentExecutionRequest } from '../types/apiRequest'
import { type ECommercePaymentExecutionResponse } from '../types/apiResponse'
import { type ECommerceV2Apis } from '../types/apis'
import { ecPaymentsQueue } from './ecPaymentsQueue'

const { useMutation } = createMutationHelper<ECommerceV2Apis['post']['eCommercePaymentExecution'], ECommercePaymentExecutionResponse, ECommercePaymentExecutionRequest>({
  client: 'eCommerceV2',
  key: '/:countryCode/payment/execution',
  fetcher: (_, { arg, client }) =>
    ecPaymentsQueue.add(() =>
      client.post(`/${arg.country_code}/payment/execution`, arg)) as AxiosPromise<ECommercePaymentExecutionResponse>,
})

export const useApiECommercePaymentExecution = useMutation
